<template>
  <div>
    <b-list-group flush>
      <b-list-group-item active-class="highlight" class="btn-custom" to="/dashboard">
        <span :class="{ highlight: highlight['1']}" class="sb-icon">
          <font-awesome-icon :icon="['fab', 'flipboard']" />
        </span>
        <span class="label">ダッシュボード</span>
      </b-list-group-item>
      <b-list-group-item active-class="highlight" class="btn-custom" to="/swipe">
        <span :class="{ highlight: highlight['9']}" class="sb-icon">
          <font-awesome-icon :icon="['fas', 'mobile-alt']" />
        </span>
        <span class="label">スワイプカード</span>
      </b-list-group-item>
      <b-list-group-item active-class="highlight" class="btn-custom" to="/intern">
        <span :class="{ highlight: highlight['7']}" class="sb-icon">
          <font-awesome-icon :icon="['fas', 'portrait']" />
        </span>
        <span class="label">インターン逆求人</span>
      </b-list-group-item>
      <b-list-group-item active-class="highlight" class="btn-custom" to="/like">
        <span :class="{ highlight: highlight['10']}" class="sb-icon">
          <font-awesome-icon :icon="['far', 'thumbs-up']" />
        </span>
        <span class="label">興味あり</span>
      </b-list-group-item>
      <!-- <b-list-group-item active-class="highlight" class="btn-custom" to="/skill">
        <span :class="{ highlight: highlight['8']}" class="sb-icon">
          <font-awesome-icon :icon="['fas', 'chart-line']" />
        </span>
        <span class="label">スキルチェッカー</span>
      </b-list-group-item> -->
      <b-list-group-item active-class="highlight" class="btn-custom" to="/chat">
        <span class="sb-icon">
          <font-awesome-icon :icon="['fas', 'comments']" />
        </span>
        <span class="label">メッセージ</span>
      </b-list-group-item>
      <b-list-group-item active-class="highlight" class="btn-custom" to="/settings/page">
        <span :class="{ highlight: highlight['5'] }" class="sb-icon">
          <font-awesome-icon :icon="['fas', 'building']" />
        </span>
        <span class="label">企業ページ</span>
      </b-list-group-item>
      <b-list-group-item :class="{ highlight: highlight['4'] }" class="btn-custom" to="/settings/base">
        <span :class="{ highlight: highlight['4'] }" class="sb-icon">
          <font-awesome-icon :icon="['fas', 'sliders-h']" />
        </span>
        <span class="label">企業情報の設定</span>
      </b-list-group-item>
      <b-list-group-item active-class="highlight" class="btn-custom divider" :href="env.GUIDE" target="_blank">
        <span class="sb-icon">
          <font-awesome-icon :icon="['fas', 'question-circle']" />
        </span>
        <span class="label">ご利用ガイド</span>
        <font-awesome-icon :icon="['fas', 'external-link-square-alt']" class="ex-link" />
      </b-list-group-item>
      <b-list-group-item active-class="highlight" class="btn-custom" href="/terms" target="_blank">
        <span class="sb-icon">
          <font-awesome-icon :icon="['fas', 'file-alt']" />
        </span>
        <span class="label">利用規約</span>
        <font-awesome-icon :icon="['fas', 'external-link-square-alt']" class="ex-link" />
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
export default {
  name: 'shared-sidebar',
  props: [
    'tab'
  ],
  computed: {
    env () {
      return this.$store.getters.env
    }
  },
  data () {
    return {
      highlight: {
        '1': false,
        '2': false,
        '3': false,
        '4': false
      }
    }
  },
  created () {
    this.setClass()
  },
  methods: {
    setClass: function () {
      this.highlight[this.tab] = true
    }
  }
}
</script>
<style scoped>
.menu {
  width: 100%;
  border-radius: 0 !important;
  background-color: #ffffff;
}

.btn-custom {
  color: #4a4a4a;
  font-weight: 400;
  border-radius: 0;
  border: none;
  height: 50px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
}

.btn-custom:hover {
  background-color: #eff1f3;
  color: #000000;
}

.highlight {
  color: #4A90E2!important;
  background-color: #fafafa!important;
}

.btn-custom .sb-icon {
  position: absolute;
  left: 20px;
  width: 20px;
  font-size: 14px;
  color: #9b9b9b;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: center;
}

.btn-custom .ex-link {
  position: absolute;
  right: 10px;
  font-size: 12px;
  color: #9b9b9b;
}

.btn-custom .label {
  position: absolute;
  left: 60px;
  font-size: 14px;
}

.btn-custom .label-settings {
  position: absolute;
  left: 75px;
  font-size: 14px;
}

.divider {
  border-top: 0.5px solid rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/share/sidebar.vue